import React, { useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import Genome from "./Genome";
import Chromosome from "./Chromosome";
import Subregion from "./Subregion";
import SubregionSelectionWrapper from "./SubregionSelectionWrapper";
import PromptClickView from "./PromptClickView";
import TrackHeader from "./TrackHeader";
import RegionHop from "./RegionHop";
import { dataFileManager } from "../dataFileManager";
import { formatGenomeData } from "../helpers/formatGenomeData";
import { getChromosomeGDMImage, getChromosomeImage, getGDMImages, getGenomeImages, initializeRecord } from "../helpers/helpers";

const Track = (props) => {

    const state = useSelector(state => state);
    const genomes = state.dashboard.genomes;
    const genomeData = formatGenomeData(genomes);
    const clades = state.dashboard.clades;
    const selectedChromosomes = state.chromosomes.current;
    const completeFilters = state.dashboard.completeFilters;
    const secondaryTrack = state.dashboard.secondaryTrack;

    const [showGDM, setShowGDM] = useState(true);

    const handleGDMChange = () => setShowGDM(!showGDM);

    const constructElement = (trackType, genome) => {
        if (trackType === "Genome") {
          return (
            <div className="track">
              {constructGenomeTrack(genome)}
            </div>
          );
        }
        else if (trackType === "Chromosome") return constructChromosomeTrack(genome);
        else if (trackType === "Subregion") return constructSubregionTrack(genome);
        else if (trackType === "SubregionSelection") return constructSubregionSelectionTrack(genome);
    }

    const constructGenomeTrack = (genome) => {
      // Grab the images needed in the track
      let requiredImgs = getGenomeImages(genome, clades, completeFilters);
      let gdmImages = getGDMImages(genome, secondaryTrack);
      return (
        <Genome
            key={`ac_${genome.genome}`}
            preprocessedImages={requiredImgs}
            preprocessedGDM={gdmImages}
            genomeData={genome}
            clade={clades}
            completeFilter={completeFilters}
        />
      )
    }

    const constructChromosomeTrack = (genome) => {
      // Grab the chosen clade images for the selected chromosome
      let requiredImgs = getChromosomeImage(genome, clades, completeFilters, selectedChromosomes[genome.genome]);
      let requiredGDMImg = getChromosomeGDMImage(genome, selectedChromosomes[genome.genome], secondaryTrack)
      return (
        <Chromosome
          key={`sc_${genome.genome}`}
          genomeData={genome} 
          preprocessedImage={requiredImgs}
          preprocessedGDM={requiredGDMImg}
          completeFilter={completeFilters}
          genes={genome.repeatData[selectedChromosomes[genome.genome]]}
          clade={clades}
      />
      )
    }

    const constructSubregionTrack = (genome) => {      
      // props.selectedRepeats[genome.genome].length > 0 &&
      const repeats = state.slider.repeatSelection[genome.genome];
      const startBoundary = state.slider.repeatStart[genome.genome];
      const endBoundary = state.slider.repeatEnd[genome.genome];
      return  (
        <div>
          <RegionHop
            key={`rh-${genome.genome}`}
            chromosome={selectedChromosomes[genome.genome]}
            genomeData={genome}
            startBoundary={startBoundary}
            endBoundary={endBoundary}
          />
          {repeats.length > 0 &&
          <Subregion
            key={`sv_${genome.genome}`}
            genomeData={genome}
            clade={clades}
            completeFilter={completeFilters}
          />
          }
        </div>
      )}

    const constructSubregionSelectionTrack = (genome) => {
            // props.clickedGenes[genome.genome].length === 0
      //   ? <PromptClickView trackName={dataFileManager[genome.genome].shortName} />
      //   : 
      return (
       <SubregionSelectionWrapper
          key={`ss_${genome.genome}`}
          genome={genome.genome}
          clade={clades}
          // calculatedPositions={props.calculatedPositions[genome.genome]}
          // submitCalculatedPositions={props.submitCalculatedPositions}
          completeFilter={completeFilters}
        />
      );
    }

    // const processedImages = genomeData.map(g => {
    //   return (
    //     <PreprocessImages genomeData={g} />
    //   )
    // });

    // Generate list of components depending on which track type is selected
    const elements = genomeData.map((g, i) => {
        return (
          <div key={"element-"+i} className="dashboard-container track-row-2">
            <p className="side-label">{dataFileManager[g.genome].shortName}</p>
            {constructElement(props.trackType, g)}
          </div>
        )
    });

    return (
      <div className="track">
        {/* {props.trackType === "Genome" &&
          <TrackHeader>
            <p>Genome</p>
            <div className="dashboard-container dashboard-related">
                <input type="checkbox" id="showGDM" name="showGDM" onChange={handleGDMChange} checked={showGDM} />
                <label htmlFor="showGDM">Show gene density map</label>
            </div>
          </TrackHeader>
        } */}
        {elements}
      </div>
    )
}
export default Track;